export const DATA_QUERY_TYPE = {
    DATA: 'data',
    RANKING: 'ranking',
    AGGREGATION: 'aggregation',
} as const;

export type DataQueryType = (typeof DATA_QUERY_TYPE)[keyof typeof DATA_QUERY_TYPE];
